// Approved About copy, mirrored in the admin app's website-about defaults.
export const DEFAULT_STRUCTURED_ABOUT_TITLE = "About SMYM Chennai";
export const DEFAULT_WEBSITE_ABOUT_SECTIONS = {
  tagline: "Seva • Sangathan • Sandesh",
  whoWeAre: {
    heading: "Who We Are",
    text: "Founded in 1980 as Maheshwari Youth Club and formally recognised by Shree Maheshwari Sabha, Chennai in 1985, SMYM is the representative body of Maheshwari youth in Chennai.",
    icon: "users",
    imageUrl: null,
  },
  vision: {
    heading: "Our Vision",
    text: "To build an engaged, responsible and forward-looking generation, rooted in values and empowered to contribute.",
    icon: "target",
    imageUrl: null,
  },
  purpose: {
    heading: "Our Purpose",
    text: "Creating opportunities for connection, personal growth, leadership and community service.",
    icon: "flag",
    imageUrl: null,
  },
  guidingHeading: "Our Guiding Principles",
  principles: [
    { id: "seva", hindi: "सेवा", english: "Service" },
    { id: "sangathan", hindi: "संगठन", english: "Unity" },
    { id: "sandesh", hindi: "संदेश", english: "Message" },
  ],
  activitiesHeading: "Our Activities",
  activities: [
    { id: "youth", label: "Youth Engagement", icon: "users", imageUrl: null },
    { id: "leadership", label: "Leadership", icon: "trending-up", imageUrl: null },
    { id: "culture", label: "Culture & Heritage", icon: "flower", imageUrl: null },
    { id: "service", label: "Community Service", icon: "hand-heart", imageUrl: null },
    { id: "sports", label: "Sports & Recreation", icon: "trophy", imageUrl: null },
    {
      id: "representation",
      label: "Community Representation",
      icon: "handshake",
      imageUrl: null,
    },
  ],
  closing: "Rooted in Values. Driven by Youth. Committed to Community.",
  affiliation: "Under the aegis of Shree Maheshwari Sabha, Chennai",
};
